import * as React from 'react';

/** Piso de largura em que a interface deixa de ser tratada como celular. */
const LARGURA_CELULAR = 768;

/**
 * Verdadeiro abaixo de 768 px. Usado por componentes que trocam de forma no
 * celular (dialogo vira gaveta, menu vira folha). O piso obrigatorio de
 * responsividade e 375 px (CLAUDE.md, "Regras de interface", item 4).
 */
export function useIsMobile(): boolean {
  const [ehCelular, setEhCelular] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const consulta = window.matchMedia(`(max-width: ${LARGURA_CELULAR - 1}px)`);
    const aoMudar = () => setEhCelular(window.innerWidth < LARGURA_CELULAR);
    consulta.addEventListener('change', aoMudar);
    aoMudar();
    return () => consulta.removeEventListener('change', aoMudar);
  }, []);

  return Boolean(ehCelular);
}
